export default __webpack_public_path__ + "static/media/img_meraki-colorBkg.c01def8e.png";